<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-boxes icon"></i>
        Bodegas
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administrativeHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'cellarsAdministrative' }">
                <span>
                  <i class="fas fa-boxes icon"></i>
                  Bodegas
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div slot="contenido">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
<BtnSearch></BtnSearch>
        <div class="columns is-desktop is-multiline">
          <div class="column is-4" v-for="list in listCellar" :key="list.id">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">{{ list.cellar.name }}</p>
              </header>
              <div class="card-content">
                <router-link
                  :to="{
                    name: `documentsAdministrative`,
                    params: { id: list.cellar.id },
                  }"
                >
                  <div class="content">
                    <div class="columns">
                      <div class="column">
                        <figure class="image is-128x128">
                          <img src="/storage-icon.png" alt="Image" />
                        </figure>
                      </div>
                      <div class="column">
                        <b-icon pack="fas" icon="file-archive" size="is-small">
                        </b-icon>
                        {{list.cant}}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import { DocumentService } from "../../../services/models/document";
import { UserCellarService } from "../../../services/models/user_cellar";
import PlantillaContenido from "../../../template/PlantillaContenido";
import BtnSearch from "../../../components/general/BtnSearch";

export default {
  components: {
    PlantillaContenido,
    BtnSearch
  },
  data() {
    return {
      listCellar: [],
      isLoading: false,
    };
  },
  mounted: function () {
    this.chargeListCellar();
  },
  methods: {
    async chargeListCellar() {
      this.isLoading = true;
      try {
        const { data: cellars } = await UserCellarService.getCellarFindByUser();
        for (let i = 0; i < cellars.length; i++) {
          console.log(cellars[i]);
          const { data: count } = await DocumentService.getCountByCellarId(
            cellars[i].cellar_id
          );
          this.listCellar.push({ ...cellars[i], cant: count });
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

